export const privacyChoicesLink = "IdSjSb";
export default {privacyChoicesLink};